import { nM } from '@/legacy';

export default () => (to, from, next) => {
  if (nM.detector.isMobile()) {
    return next('/please-use-desktop');
  }

  return next();
};
